import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import {OurContextProvider }from './components/context/context';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <OurContextProvider>
    <App />
  </OurContextProvider>
  </BrowserRouter>
);

